module.exports = __webpack_public_path__ + "ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ec.svg
// module id = 528
// module chunks = 0